/**
 * Drops HTTP work that outlives the open record.
 *
 * Vue documents this as watcher side-effect cleanup: abort the request when the
 * watched value changes, and do not apply a result that resolves afterwards.
 * https://vuejs.org/guide/essentials/watchers.html#side-effect-cleanup
 *
 * routeContext is the source of truth for the open record, so one AbortController
 * is rotated when that record changes. Each loader remembers the epoch it started
 * with and ignores both a canceled request and a response for a record the user left.
 */

let controller = new AbortController()
let epoch = 0

export function currentViewEpoch(): number {
  return epoch
}

export function currentViewSignal(): AbortSignal {
  return controller.signal
}

export function isStaleView(epochAtStart: number): boolean {
  return epochAtStart !== epoch
}

/** Abort every view request still in flight and start a new epoch. */
export function advanceViewRequests(): void {
  controller.abort()
  controller = new AbortController()
  epoch += 1
}

export function isRequestCanceled(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const err = error as { code?: string; name?: string }
  return err.code === 'ERR_CANCELED' || err.name === 'CanceledError' || err.name === 'AbortError'
}
